
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import store from '@/store';
import { NetworkClient } from '@/services/Services';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class networkCounterBox extends Vue {

    @Prop() userIdentifier: string;

    firstLineActive: number = 0;
    firstLineTotal: number = 0;
    descendantsActive: number = 0;
    // descendantsTotal: number = 0;
    
    created() {
        let userId: string = "";
        if(this.userIdentifier){
            userId = this.userIdentifier;
        } else {
            userId = store.state.user.identifier;
        }

        NetworkClient.countFirstLine(userId, true).then(x => this.firstLineActive = x);
        NetworkClient.countFirstLine(userId, false).then(x => this.firstLineTotal = x);
        NetworkClient.countAllDescendant(userId, true).then(x => this.descendantsActive = x);
        // NetworkClient.countAllDescendant(userId, false).then(x => this.descendantsTotal = x);
    }

}
